export const tariffChargeUnitTypes = ['Volume', 'KG', 'Chargeable', 'W/M', 'Ton', 'Container', 'Shipment', 'Pieces'] as const;
export type ChargeUnitType = typeof tariffChargeUnitTypes[number];
